export default "__VITE_ASSET__BWmMgnpb__"